import { ChangeDetectionStrategy, ChangeDetectorRef, Component, ViewEncapsulation } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import {
  GlameraIconBase,
  GlameraIconDefinition,
  GLAMERA_ICON_HOST_TEMPLATE,
} from '@glamera/animated-icons/core';

export const GLM_SCREEN_SHARE: GlameraIconDefinition = {
  name: 'screen-share',
  viewBox: '0 0 24 24',
  svg: `
    <path class="glm-screen-share-part glm-screen-share-screen" d="M13 3H4a2 2 0 0 0-2 2v10a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2v-3"></path>
    <path class="glm-screen-share-part glm-screen-share-base" d="M8 21h8"></path>
    <path class="glm-screen-share-part glm-screen-share-stem" d="M12 17v4"></path>
    <path class="glm-screen-share-part glm-screen-share-arrow-line" d="m17 8 5-5"></path>
    <path class="glm-screen-share-part glm-screen-share-arrow-corner" d="M17 3h5v5"></path>
  `.trim(),
};

@Component({
  standalone: true,
  selector: 'glamera-screen-share-icon',
  template: GLAMERA_ICON_HOST_TEMPLATE,
  styleUrls: ['../../core/src/lib/base/icon-base.scss', './screen-share.animation.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  encapsulation: ViewEncapsulation.None,
})
export class ScreenShareIconComponent extends GlameraIconBase {
  readonly iconDef = GLM_SCREEN_SHARE;

  constructor(sanitizer: DomSanitizer, cdr: ChangeDetectorRef) {
    super(sanitizer, cdr);
  }
}
